module.exports = __webpack_public_path__ + "img/loader.77b8ede4.gif";